import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";
import { Redirect, Route, Switch, useParams, useHistory } from "react-router";
import { FieldList } from "../components/FieldList";
import { ModelHeader } from "../components/ModelHeader";
import { AddFieldModal } from "../components/AddFieldModal";
import { ModelInfo } from "../components/ModelInfo";
import { useGetContentModelsQuery } from "../../../../../shell/services/instance";
import { NotFound } from "../../../../../shell/components/NotFound";
import SchemaRoundedIcon from "@mui/icons-material/SchemaRounded";
import { ModelActivityLog } from "../components/ModelActivityLog";
import { ModelApi } from "../components/ModelApi";
type Params = {
  id: string;
};
export const Model = () => {
  const {
    t
  } = useTranslation();
  const [isAddFieldModalOpen, setAddFieldModalOpen] = useState(false);
  const [sortIndex, setSortIndex] = useState<number | null>(null);
  const history = useHistory();
  const params = useParams<Params>();
  const {
    id
  } = params;
  const {
    data: models,
    isFetching
  } = useGetContentModelsQuery();
  const handleNewFieldModalClick = (sortIndex: number | null) => {
    setAddFieldModalOpen(true);
    setSortIndex(sortIndex);
  };
  const handleModalClosed = () => {
    setAddFieldModalOpen(false);
    setSortIndex(null);
  };
  if (!isFetching && !models?.find(model => model.ZUID === id)) {
    return <NotFound title="Model Not Found" message="We're sorry the model you requested could not be found. Please go back to the All Models page." button={<Button startIcon={<SchemaRoundedIcon />} variant="contained" onClick={() => history.push("/schema")}>
            {t("schema.goToAllModels")}
          </Button>} />;
  }
  return <Box flex="1" display="flex" height="100%" flexDirection="column" sx={{
    backgroundColor: "grey.50"
  }} data-sentry-element="Box" data-sentry-component="Model" data-sentry-source-file="Model.tsx">
      <ModelHeader onNewFieldModalClick={handleNewFieldModalClick} data-sentry-element="ModelHeader" data-sentry-source-file="Model.tsx" />
      <Route path="/schema/:id/fields/:fieldId" render={() => {
      return <AddFieldModal mode="update_field" onModalClose={() => history.push(`/schema/${id}/fields`)} />;
    }} data-sentry-element="Route" data-sentry-source-file="Model.tsx" />
      <Switch data-sentry-element="Switch" data-sentry-source-file="Model.tsx">
        <Route path="/schema/:id/fields" render={() => <FieldList onNewFieldModalClick={handleNewFieldModalClick} />} data-sentry-element="Route" data-sentry-source-file="Model.tsx" />
        <Route path="/schema/:id/api" component={ModelApi} data-sentry-element="Route" data-sentry-source-file="Model.tsx" />
        <Route exact path="/schema/:id/info" component={ModelInfo} data-sentry-element="Route" data-sentry-source-file="Model.tsx" />
        <Route exact path="/schema/:id/activity-log" component={ModelActivityLog} data-sentry-element="Route" data-sentry-source-file="Model.tsx" />
        <Redirect to="/schema/:id/fields" data-sentry-element="Redirect" data-sentry-source-file="Model.tsx" />
      </Switch>
      {isAddFieldModalOpen && <AddFieldModal mode="fields_list" onModalClose={handleModalClosed} sortIndex={sortIndex} />}
    </Box>;
};